import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';
import { buttonsReset } from 'src/store/modules/buttons';
import { customlogReset } from 'src/store/modules/customlog';
import { editTextReset } from 'src/store/modules/editText';
import { imageReset } from 'src/store/modules/imageUpload';
import { pagesReset } from 'src/store/modules/pages';

import setInitValue from 'src/utils/setInitValue';
import { changeEnter } from 'src/utils/changeEnter';
import { editUserCompany } from 'src/store/modules/client';
import CloseIcon from '@material-ui/icons/Close';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';
import { initTrackingValues } from '../TemplateTracking/AlarmModalTracking';

const initViewValues = {
  bg: 'color',
  bgOpacity: { bgDimmed: 70 },
  bgColor: { background: '#ffffff' },
  bgImage: {
    logo: 'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp'
  },
  radius: { background: 14, button: 4 },
  deeplink: { background: 'https://www.inappmessage.com/' },

  text: {
    title: 'Get Coins for free!',
    sub_title:
      'If you read New Series more than 3 times, you will receive 3 Coins.'
  },
  fontSize: { title: 1.25, sub_title: 0.8125 },
  fontWeight: { title: 700, sub_title: 400 },
  color: { title: '#000000', sub_title: '#000000' },
  fontFamily: { title: 'Inter', sub_title: 'Inter' },
  textAlign: { title: 'center', sub_title: 'center' },

  btnText: {
    button: 'Read Now',
    sub_button: 'Close',
    never_show_button: "Don't show"
  },
  btnFontSize: { button: 1, sub_button: 0.875, never_show_button: 0.875 },
  btnFontWeight: { button: 700, sub_button: 400, never_show_button: 400 },
  btnColor: {
    button: '#ffffff',
    sub_button: '#ffffff',
    never_show_button: '#ffffff'
  },
  btnBgColorR: { button: 0, sub_button: 0, never_show_button: 0 },
  btnBgColorG: { button: 220, sub_button: 0, never_show_button: 0 },
  btnBgColorB: { button: 100, sub_button: 0, never_show_button: 0 },
  btnBgColorA: { button: 1, sub_button: 0, never_show_button: 0 },
  btnFontFamily: {
    button: 'Inter',
    sub_button: 'Inter',
    never_show_button: 'Inter'
  },
  btnAgain: {
    type: 'attribute',
    never_show_button: 'opt-in'
  },
  button1: {
    button: [],
    left_button: [],
    right_button: []
  },
  button2: {
    button: [],
    left_button: [],
    right_button: []
  }
};
const SimpleIconModal: FC = () => {
  const dispatch = useDispatch();
  const [currentUser, setCurrentUser] = useState('');

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        setCurrentUser(current.attributes['custom:Company']);
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  const templateWidth = useSelector(
    (state: any) => state.template.templateWidth
  );

  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );

  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const btnFontURL = getFontURL(btnFontFamily?.button);
  const btnFontSubURL = getFontURL(btnFontFamily?.sub_button);
  const btnFontNeverShowURL = getFontURL(btnFontFamily?.never_show_button);
  // const titleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.title}`;
  // const subTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.sub_title}`;
  // const btnFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.button}`;
  // const btnFontSubURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.sub_button}`;
  // const btnFontNeverShowURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.never_show_button}`;

  const style = `
  @font-face {
    font-family: 'titleFont';
    src: url(${titleFontURL});
    }

  @font-face {
    font-family: 'subTitleFont';
    src: url(${subTitleFontURL});
    }

  @font-face {
    font-family: 'btnFont';
    src: url(${btnFontURL});
    }

  @font-face {
    font-family: 'btnSubFont';
    src: url(${btnFontSubURL});
    }

  @font-face {
    font-family: 'btnNeverShowFont';
    src: url(${btnFontNeverShowURL});
    }

  .root_view {
    width: 100%;
    height: 100%;
    
    position: relative;
    background: none;
    overflow: hidden;
    
    .background {
      width: 100%;
      height: 100%;           
      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, ${displayValue});
      padding: 0 10%;
    }
    .center {
      width: 80%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;      
    }
    .modal_wrapper {
      width: 100%;
      padding: 1.62rem 1.25rem 1.25rem 1.25rem;

      display: flex;
      flex-direction: column;      
      gap: 1rem;
      border-radius: ${radius?.background}px;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .icon {
      text-align: center;    
    }
    .icon img {     
      min-width: 70px;
      min-height: 70px;
      max-width: 140px;
      max-height: 140px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }

    .title {
      display: flex;
      align-items: center; 
      margin-bottom: 7px;
    }
    .title_inner {
      width: 100%;
      height: auto;      
      line-height: 1.4;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.title};
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily.title
          : 'titleFont'
      };
    }
    .sub_title {      
      display: flex;
      align-items: center;
    }
    .sub_title_inner {
      width: 100%;
      height: auto;
      max-height: 3rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-height: 1.54;
      text-align: ${textAlign?.sub_title};
      color: ${color?.sub_title};
      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily.sub_title
          : 'subTitleFont'
      };
    }

    .btn_wrapper {
      width: 100%;      
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;
      outline: 0;
      border: 0;
      padding: 0 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-weight: ${btnFontWeight?.button};
      font-size: ${btnFontSize?.button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily?.button
          : 'btnFont'
      };

      color: ${btnColor?.button};
      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button},
        ${btnBgColorB?.button}, ${btnBgColorA?.button});
    }
 
    .bottom_wrapper {
      margin-top: 11px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 0.25rem;
    }
    .bottom_wrapper .style01 {
      width: 100%;
      display: flex;
      align-items: center;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.never_show_button};
      font-weight: ${btnFontWeight?.never_show_button};
      font-size: ${btnFontSize?.never_show_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.never_show_button
        )
          ? btnFontFamily.never_show_button
          : 'btnNeverShowFont'
      };
      
      background-color:rgba(
      ${btnBgColorR?.never_show_button},${btnBgColorG?.never_show_button},
      ${btnBgColorB?.never_show_button}, ${btnBgColorA?.never_show_button});
    }
    .bottom_wrapper .style02 {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.sub_button};
      font-weight: ${btnFontWeight?.sub_button};
      font-size: ${btnFontSize?.sub_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.sub_button
        )
          ? btnFontFamily.sub_button
          : 'btnSubFont'
      };
      
      background-color:rgba(
        ${btnBgColorR?.sub_button},${btnBgColorG?.sub_button}, 
        ${btnBgColorB?.sub_button},${btnBgColorA?.sub_button});
    }
   
    ${
      templateWidth > 767
        ? `
        .center {
          width: 50%;
        }
        .modal_wrapper {
          padding: 2rem;
        }

        .title {
          height: 4.5rem;
        }
        .title_inner {
          max-height: 3.8rem;
          font-size: ${fontSize?.title + 0.5}rem;
        }
        .sub_title {
          height: 4rem;
        }
        .sub_title_inner {
          font-size: ${fontSize?.sub_title + 0.125}rem;
        }
  
        .bottom_wrapper .style01 {
          font-size: ${btnFontSize?.never_show_button + 0.25}rem;
        }
        .bottom_wrapper .style02 {
          font-size: ${btnFontSize?.sub_button + 0.25}rem;
        }
        `
        : ''
    }
  }
  `;

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(customlogReset());
      dispatch(trackingReset());
    };
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view">
        <div className="background" />
        <div className="center">
          <div className="modal_wrapper">
            <div className="icon">
              <img
                src={bgImage?.logo}
                alt="icon"
                decoding="async"
                loading="lazy"
              />
            </div>
            <div>
              <div className="title">
                <div className="title_inner">{changeEnter(text?.title)}</div>
              </div>
              <div className="sub_title">
                <div className="sub_title_inner">
                  {changeEnter(text?.sub_title)}
                </div>
              </div>
            </div>
            <div className="btn_wrapper">
              <button className="button">{btnText?.button}</button>
            </div>
          </div>
          <div className="bottom_wrapper">
            <span className="style01">{btnText?.never_show_button}</span>
            <span className="style02">
              {btnText?.sub_button}
              <CloseIcon
                style={{
                  fontSize: `${btnFontSize?.sub_button + 0.25}rem`,
                  color: `${btnColor?.sub_button}`
                }}
              />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default SimpleIconModal;
